import { Input } from 'antd'
import styled from 'styled-components'

export const PageContainer = styled.div`
  width: 100%;
  height: 100vh;
  height: 100dvh;
  background: #fffafa;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 72px 16px 24px;
  box-sizing: border-box;
  overflow: auto;
`

export const Logo = styled.img`
  position: absolute;
  top: 24px;
  left: 32px;
  width: 40px;
  height: 40px;
  z-index: 10;

  @media (max-width: 480px) {
    top: 16px;
    left: 16px;
  }
`

export const Container = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--color-bg);
  box-sizing: border-box;
`

export const LoginBox = styled.div`
  width: 384px;
  max-width: 100%;
  height: auto;
`

export const LoginDetails = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const InputWrapper = styled.div`
  width: 100%;
`

export const Label = styled.label`
  color: var(--text-color-primary);
  font-size: 16px;
  font-weight: 400;
  line-height: 130%;
  display: inline-block;
  margin-bottom: 10px;
  margin-left: 2px;
`

export const ErrorWrapper = styled.div`
  width: 100%;
  color: #e33939;
  font-size: 12px;
  font-weight: 400;
  line-height: 100%;
  display: inline-block;
  margin-top: 5px;
  margin-left: 2px;
`

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 19px;
`

export const StyledInput = styled(Input)`
  &::placeholder {
    color: #007f7c !important;
  }

  /* Ensures cross-browser support */
  &::-webkit-input-placeholder {
    color: #007f7c !important;
  }
  &:-ms-input-placeholder {
    color: #007f7c !important;
  }
`
